import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconKeyboardBackspaceSvg } from "./IconKeyboardBackspaceSvg.mjs";
const IconKeyboardBackspace = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconKeyboardBackspaceSvg, ...iconProps });
};
export {
  IconKeyboardBackspace
};
